import Common from '../CommonNctv';
import { cardItem } from "../CardTmpl";
import TopButton from '../TopButton';
import ChannelInfo from './ChannelInfo';
import OfficialLive from './OfficialLive';
import HistoryBack from './HistoryBack';
import Util from '../Util';

class AbsList {
    constructor( _option={}, _alias='', _container='') {
        this.apiDomain = _option.apiDomain;
        this.com = Common.instance;
        this.com.init();
        this.cardItemTmpl = cardItem;
        this.container = _container;
        this.alias = _alias;
        this.page = _option.page ?  _option.page : 1;
        this.order = _option.order ? _option.order : 'date';
        this.query = _option.query ? _option.query : '';
        this.filter = Util.getParamByName('filter') || '';
        this.gamelog =  this.filter ?  Util.getParamByName('filter').indexOf('gamelog') > -1 : false;
       // this.gamelogOnly = _option.gamelogOnly ? _option.gamelogOnly : false;
        this.videoKind = _option.videoKind ? _option.videoKind : (Util.getParamByName('videoKind') || '');
        this.official = (this.videoKind == 'OFFICIAL') ? true : false;
        this.channelInfo = _option.officialInfo ? new ChannelInfo(_option.officialInfo) : '';
        this.historyBack = new HistoryBack(this.alias, this.container);
        // this.addElements();
        // this.addEvents();
        // this.init();
    }

    init(){
        const storage = JSON.parse(this.historyBack.getStorage());
        new TopButton();

        if(storage && this.query === storage.query){
            this.order = storage.order;
            this.page = storage.page;
            this.listData = {last: storage.isLast};
            $( this.container ).html(  storage.list );
            this.setOrderActive();
            this.toggleMoreButton();
            // this.historyBack.removeStorage();
        }else{
            this.loadListData();
        }
        this.historyBack.removeStorage();

        if(this.alias === 'esports'){ //이스포츠일때
            new OfficialLive(this.alias);
        }

        this.el.GamelogOption.prop('checked', this.gamelog); //게임 로그 옵션 체크
        this.el.OfficialOption.prop('checked', this.official); //공식 영상 옵션 체크
    }

    loadListData(){
        $.ajax ( {
            type: "GET",
            contentType: "application/json",
            url: this.apiDomain + `/v1/videos/${this.alias}`,
            async: 'false',
            data: this.getDataParams()
        })
        .fail( ( _e)=>{ console.log(_e) })
        .done( ( _d )=>{
            this.listData = _d.data;
            this.setTemplate();
            this.toggleMoreButton();
            this.toggleEmpty();
            $('.contents').trigger('LOAD_LIST_DATA', this.listData);
        });
    }

    // ajax에서 사용할 파라미터
    getDataParams(){
        return {
          game : this.com.ip,
          page : this.page,
          pageSize: 20,
          order: this.order,
          filter: this.filter
      };
    }

    setTemplate(){
        const cardData = this.listData.content;
        const list = cardData.map( (item, idx) => this.cardItemTmpl(item, this.alias, 'E')).join('');
        $( this.container ).append( list );
    }

    //정렬눌러 다시 목록 그릴때
    setTemplateByOder(_e){
        _e.preventDefault();
        this.order= $(_e.target).attr('data-order');

        $( this.container ).html( '' );
        this.page = 1;
        this.loadListData();
        this.setOrderActive();
    }

    //페이지징 + 1해서 더 가져오기
    updateList(_e){
        _e.preventDefault();
        this.page = this.page + 1;
        this.loadListData();
    }
    //마지막 페이지면 더보기 버튼 가리기;
    toggleMoreButton(){
        this.listData.last ? this.el.moreBtn.hide() : this.el.moreBtn.show()
    }

    //리스트 목록 없을 때 
    toggleEmpty(){
        if(!this.listData.contentSize){
            this.el.emptyWrap.css('display', 'block');
            this.el.resultWrap.hide();
            this.el.orderBtn.hide();
            this.el.filterWrap.hide();
        }
    }

    //정렬 확성화
    setOrderActive(){
        this.el.orderBtn.removeClass('is-active');
        $(`[data-order="${this.order}"]`).addClass('is-active');
    }

    //게임로그 옵션 선택 
    clickGamelogOption(){
        if(this.el.GamelogOption.prop('checked')){
            window.location.href = Util.addParam( 'filter',  'gamelogOnly', Util.removeParam('videoKind', 'OFFICIAL'));
        }else{
            window.location.href = Util.removeParam('filter', 'gamelogOnly');
        }
    }

    //공식영상 옵션 선택
    clickOfficialOption(){
        if(this.el.OfficialOption.prop('checked')){
            window.location.href = Util.addParam( 'videoKind',  'OFFICIAL', Util.removeParam('filter', 'gamelogOnly'));
        }else{
            window.location.href = Util.removeParam('videoKind', 'OFFICIAL');
        }
    }

    addElements(){
        this.el = {
            moreBtn: $('.more-list'),
            orderBtn: $('[data-order]'),
            emptyWrap: $('[data-result="empty"]'),
            resultWrap: $('[data-result="wrap"]'),
            filterWrap: $('.list-filters'),
            GamelogOption: $('#gamelogOnly'),
            OfficialOption: $('#OFFICIAL')
        }
    }
    addEvents(){
        this.el.moreBtn.on('click', (_e) => {this.updateList(_e)});
        this.el.orderBtn.on('click', (_e) => {this.setTemplateByOder(_e)});
        this.el.GamelogOption.on('click', (_e) => {this.clickGamelogOption(_e)});
        this.el.OfficialOption.on('click', (_e) => {this.clickOfficialOption(_e)});
        $( this.container ).on('click', 'a', (_e) => {
            this.historyBack.setHistoryBack({
                order : this.order,
                page : this.page,
                query : this.query,
                isLast: this.listData.last
            });
        });
    }
} // end of class
export default AbsList;
